import {
  AccumulateRow,
  AudiencesRow,
  BuyAndWinRow,
  BuyTogetherRow,
  ConditionsRow,
  MoreForLessRow,
  NameRow,
  ProgressiveDiscountRow,
  RegularRow,
  RestrictionsRow,
  SalesChannelsRow,
  SchedulingRow,
  SellersRow,
} from './Fields'

import { SummaryContainer } from 'ui'
import { BudgetRow } from './Fields/Budget'

export const Summary = {
  Container: SummaryContainer,
  Conditions: ConditionsRow,
  Restrictions: RestrictionsRow,
  Scheduling: SchedulingRow,
  Name: NameRow,
  Accumulate: AccumulateRow,
  BuyTogether: BuyTogetherRow,
  BuyAndWin: BuyAndWinRow,
  SalesChannels: SalesChannelsRow,
  Budget: BudgetRow,
  Sellers: SellersRow,
  MoreForLess: MoreForLessRow,
  ProgressiveDiscount: ProgressiveDiscountRow,
  Regular: RegularRow,
  Audiences: AudiencesRow,
}
